import React from 'react'
import { useTranslation } from 'react-i18next'
import ArticlesCodesInput from './ArticlesCodesInput'
import { Button, Card, CardContent, CardHeader, Divider, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { Alert } from '@carsys/ui'

export interface ArticlesCodesProps {
  title: string
  codes: string[] | number[]
  type: string
  codesType: string
  remove: <T>(index: number) => T | undefined
  push: (obj: any) => void
}

export const ArticlesCodes: React.FC<ArticlesCodesProps> = ({ title, codes, codesType, type, remove, push }) => {
  const { t } = useTranslation()

  return (
    <Card variant='outlined'>
      <CardHeader
        title={<Typography variant='h5'>{title}</Typography>}
        action={
          <Button data-testid='add-code-btn' fullWidth variant='outlined' onClick={() => push('')} startIcon={<AddIcon />}>
            {t('global.add')}
          </Button>
        }
      />

      <Divider />
      <CardContent>
        {!codes || (codes.length === 0 && <Alert color='muted'>{t('productgroup.alertNoCodes')}</Alert>)}
        {codes &&
          codes.length > 0 &&
          codes.map((_code, index) => {
            return (
              <ArticlesCodesInput
                key={`${codesType}[${index}]-${index}`}
                index={index}
                name={`${codesType}[${index}]`}
                type={type}
                remove={remove}
              />
            )
          })}
      </CardContent>
    </Card>
  )
}

ArticlesCodes.displayName = 'ArticlesCodes'

export default ArticlesCodes
